class HikariFvSlideshow extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    if (!this.track) return;

    this.slides = Array.from(this.track.querySelectorAll('.hikari-fv__slide'));
    if (this.slides.length === 0) return;

    this.dots = Array.from(this.querySelectorAll('[data-dot]'));
    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');
    this.currentIndex = 0;
    this.autoplayInterval = null;
    this.autoplayMs = 0;

    this.bindEvents();

    const autoplayAttr = this.getAttribute('autoplay');
    if (autoplayAttr) {
      const seconds = parseInt(autoplayAttr, 10) || 5;
      this.autoplayMs = seconds * 1000;
      this.startAutoplay();
    }
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.goTo(this.currentIndex - 1);
        this.restartAutoplay();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.goTo(this.currentIndex + 1);
        this.restartAutoplay();
      });
    }

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this.goTo(i);
        this.restartAutoplay();
      });
    });

    let scrollTimer;
    this.track.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => this.syncIndexFromScroll(), 100);
    });
  }

  goTo(index) {
    const total = this.slides.length;
    const newIndex = ((index % total) + total) % total;
    this.currentIndex = newIndex;
    const target = this.slides[newIndex];
    if (target) {
      this.track.scrollTo({
        left: target.offsetLeft,
        behavior: 'smooth',
      });
    }
    this.updateDots();
  }

  syncIndexFromScroll() {
    const slideWidth = this.slides[0].offsetWidth;
    if (!slideWidth) return;
    const newIndex = Math.round(this.track.scrollLeft / slideWidth);
    if (newIndex !== this.currentIndex && newIndex >= 0 && newIndex < this.slides.length) {
      this.currentIndex = newIndex;
      this.updateDots();
    }
  }

  updateDots() {
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.currentIndex);
    });
  }

  startAutoplay() {
    if (!this.autoplayMs) return;
    this.stopAutoplay();
    this.autoplayInterval = setInterval(() => {
      this.goTo(this.currentIndex + 1);
    }, this.autoplayMs);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  restartAutoplay() {
    if (this.autoplayMs) this.startAutoplay();
  }
}

if (!customElements.get('hikari-fv-slideshow')) {
  customElements.define('hikari-fv-slideshow', HikariFvSlideshow);
}
